export enum CreatePlanStepFieldName {
  PLAN_STYLE = 'PLAN_STYLE',
  PLAN_NAME = 'PLAN_NAME',
  PLAN_DESCRIPTION = 'PLAN_DESCRIPTION',
  IFT_REGISTRATION_NUMBER = 'IFT_REGISTRATION_NUMBER',
  LINE_TYPES = 'LINE_TYPES',
  EXTERNAL_SKU = 'EXTERNAL_SKU',
  PLAN_CLASS = 'PLAN_CLASS',
  PLAN_DURATION = 'PLAN_DURATION',
  MNO_SUBSCRIPTION = 'MNO_SUBSCRIPTION',
  DEDICATED_DATA = 'DEDICATED_DATA',
  GENERAL_DATA = 'GENERAL_DATA',
  LOW_SPEED_DATA = 'LOW_SPEED_DATA',
  VOICE_CALL = 'VOICE_CALL',
  SMS = 'SMS',
  LIST_PRICE = 'LIST_PRICE',
  PAYMENT_CHANNEL = 'PAYMENT_CHANNEL',
  BILL_ON = 'BILL_ON',
  BILL_TO = 'BILL_TO',
}
